import { mix } from './mix.es.js';
import { progress } from './progress.es.js';

function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for (let i = 1; i <= remaining; i++) {
        const offsetProgress = progress(0, remaining, i);
        offset.push(mix(min, 1, offsetProgress));
    }
}
function defaultOffset(length) {
    const offset = [0];
    fillOffset(offset, length - 1);
    return offset;
}

export { defaultOffset, fillOffset };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/utils/dist/offset.es.js
// module id = 0DeU
// module chunks = 0